import { render, staticRenderFns } from "./UnitNavigationTile.vue?vue&type=template&id=bea1b694&"
import script from "./UnitNavigationTile.vue?vue&type=script&lang=js&"
export * from "./UnitNavigationTile.vue?vue&type=script&lang=js&"
import style0 from "./UnitNavigationTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bea1b694', component.options)
    } else {
      api.reload('bea1b694', component.options)
    }
    module.hot.accept("./UnitNavigationTile.vue?vue&type=template&id=bea1b694&", function () {
      api.rerender('bea1b694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitNavigationTile.vue"
export default component.exports